'use strict';

var cov_gtrfa7vvc = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\xemhantamtai\\xemhantamtai.js',
      hash = '6148895a2c08698e4851c1d5e5e9116f532d765f',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\xemhantamtai\\xemhantamtai.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 39,
          column: 6
        }
      },
      '1': {
        start: {
          line: 4,
          column: 25
        },
        end: {
          line: 8,
          column: 7
        }
      },
      '2': {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 12,
          column: 7
        }
      },
      '3': {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 38,
          column: 9
        }
      },
      '4': {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 19,
          column: 22
        }
      },
      '5': {
        start: {
          line: 20,
          column: 10
        },
        end: {
          line: 32,
          column: 11
        }
      },
      '6': {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 31,
          column: 13
        }
      },
      '7': {
        start: {
          line: 22,
          column: 14
        },
        end: {
          line: 27,
          column: 15
        }
      },
      '8': {
        start: {
          line: 23,
          column: 29
        },
        end: {
          line: 23,
          column: 42
        }
      },
      '9': {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 26,
          column: 17
        }
      },
      '10': {
        start: {
          line: 25,
          column: 18
        },
        end: {
          line: 25,
          column: 144
        }
      },
      '11': {
        start: {
          line: 30,
          column: 14
        },
        end: {
          line: 30,
          column: 85
        }
      },
      '12': {
        start: {
          line: 33,
          column: 10
        },
        end: {
          line: 33,
          column: 31
        }
      },
      '13': {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 40
        }
      },
      '14': {
        start: {
          line: 43,
          column: 0
        },
        end: {
          line: 48,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 40
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 3,
            column: 24
          },
          end: {
            line: 3,
            column: 25
          }
        },
        loc: {
          start: {
            line: 3,
            column: 36
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 3
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 18,
            column: 26
          },
          end: {
            line: 18,
            column: 27
          }
        },
        loc: {
          start: {
            line: 18,
            column: 40
          },
          end: {
            line: 34,
            column: 9
          }
        },
        line: 18
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 35,
            column: 14
          },
          end: {
            line: 35,
            column: 15
          }
        },
        loc: {
          start: {
            line: 35,
            column: 25
          },
          end: {
            line: 38,
            column: 7
          }
        },
        line: 35
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        }, {
          start: {
            line: 21,
            column: 12
          },
          end: {
            line: 31,
            column: 13
          }
        }],
        line: 21
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var XemhantamtaiController = function XemhantamtaiController($scope, $rootScope, $http) {
  _classCallCheck(this, XemhantamtaiController);

  ++cov_gtrfa7vvc.f[0];
  ++cov_gtrfa7vvc.s[0];

  $scope.submitForm = function () {
    ++cov_gtrfa7vvc.f[1];

    var dataSubmit = (++cov_gtrfa7vvc.s[1], {
      dd: $scope.dd.value,
      mm: $scope.mm.value,
      yy: $scope.yy
    });
    var config = (++cov_gtrfa7vvc.s[2], {
      params: dataSubmit,
      headers: { Accept: 'application/json' }
    });
    ++cov_gtrfa7vvc.s[3];
    $http({
      method: 'POST',
      url: $rootScope.apiOpen + 'tracuu/hantamtai/',
      data: dataSubmit,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: function transformRequest(obj) {
        ++cov_gtrfa7vvc.f[2];

        var str = (++cov_gtrfa7vvc.s[4], []);
        ++cov_gtrfa7vvc.s[5];
        for (var key in obj) {
          ++cov_gtrfa7vvc.s[6];

          if (obj[key] instanceof Array) {
            ++cov_gtrfa7vvc.b[0][0];
            ++cov_gtrfa7vvc.s[7];

            for (var idx in obj[key]) {
              var subObj = (++cov_gtrfa7vvc.s[8], obj[key][idx]);
              ++cov_gtrfa7vvc.s[9];
              for (var subKey in subObj) {
                ++cov_gtrfa7vvc.s[10];

                str.push(encodeURIComponent(key) + "[" + idx + "][" + encodeURIComponent(subKey) + "]=" + encodeURIComponent(subObj[subKey]));
              }
            }
          } else {
            ++cov_gtrfa7vvc.b[0][1];
            ++cov_gtrfa7vvc.s[11];

            str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
          }
        }
        ++cov_gtrfa7vvc.s[12];
        return str.join("&");
      }
    }).then(function (results) {
      ++cov_gtrfa7vvc.f[3];
      ++cov_gtrfa7vvc.s[13];

      // $http.get($rootScope.apiOpen + 'tracuu/hantamtai/', config).then(results => {
      $scope.dataprint = results.data;
    });
  };
};

++cov_gtrfa7vvc.s[14];


angular.module('app').component('xemhantamtai', {
  templateUrl: 'app/xemhantamtai/xemhantamtai.html',
  controller: XemhantamtaiController
});